// Translation for pl
export const pl = {
        common: {
            save: 'Zapisz',
            cancel: 'Anuluj',
            close: 'Zamknij',
            delete: 'Usuń',
            edit: 'Edytuj',
            activate: 'Aktywuj',
            add: 'Dodaj',
            saving: 'Zapisywanie...',
            loading: 'Ładowanie...',
            active: 'AKTYWNY',
            inUse: 'W Użyciu',
            test: 'Test',
            searchApps: 'Szukaj aplikacji...',
            betaBanner: 'BETA - Serwis niedostępny!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Zaloguj się',
            signUp: 'Zarejestruj się',
            username: 'Nazwa użytkownika',
            password: 'Hasło',
            continue: 'Kontynuuj',
            noAccount: 'Nie masz konta?',
            hasAccount: 'Już masz konto?',
            loginError: 'Logowanie nie powiodło się',
            invalidCredentials: 'Nieprawidłowa nazwa użytkownika lub hasło',
            rateLimited: 'Zbyt wiele prób logowania. Czekaj chwilę.',
            sessionExpired: 'Twoja sesja wygasła. Użyj nowego magicznego linku.',
            magicLinkInvalid: 'Link logowania jest nieprawidłowy lub wygasł.',
            magicLinkSuccess: 'Witaj! Zostałeś pomyślnie zalogowany.',
            magicLinkProcessing: 'Przetwarzanie logowania...',
            connectionError: 'Błąd połączenia. Spróbuj ponownie.'
        },
        profile: {
            myProgress: 'Mój Postęp Nauki',
            signOut: 'Wyloguj się',
            plan: 'Plan: '
        },
        settings: {
            title: 'Ustawienia',
            tabs: {
                uiSettings: 'Ustawienia UI',
                systemPrompt: 'Prompt Systemowy',
                llmProfiles: 'Profile LLM',
                ttsProfiles: 'Profile TTS',
                language: 'Język',
            },
            uiSettings: {
                title: 'Interfejs Użytkownika',
                themeMode: 'Tryb Motywu',
                darkMode: 'Tryb Ciemny',
                lightMode: 'Tryb Jasny',
                themeColor: 'Kolor Motywu',
                themeColorDesc: 'Wybierz kolor akcentu dla przycisków, ikon i wyróżnień',
                background: 'Tło',
                backgroundDesc: 'Wybierz tło dla swojej przestrzeni roboczej',
                selectBackgroundColor: 'Wybierz Kolor Tła',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Skupienie',
                    concentration: 'Koncentracja',
                    relaxation: 'Relaksacja',
                    lianas: 'Liany',
                    color: 'Kolor'
                },
                backgroundColors: {
                    deepDark: 'Głębokie Czarne',
                    darkGrey: 'Ciemny Szary',
                    midnightBlue: 'Północny Błękit',
                    indigo: 'Indygo',
                    darkTeal: 'Ciemny Cyjanowy',
                    brown: 'Brązowy',
                    darkRed: 'Ciemny Czerwony',
                    deepPurple: 'Głębokie Fioletowe',
                    pureWhite: 'Czyste Białe',
                    softWhite: 'Miękkie Białe',
                    lightGrey: 'Jasny Szary',
                    paleBlue: 'Blady Błękit',
                    paleGreen: 'Blady Zielony',
                    paleOrange: 'Blady Pomarańczowy',
                    lavender: 'Lawenda',
                    blueGrey: 'Błękitny Szary'
                }
            },
            systemPrompt: {
                label: 'Prompt Systemowy:',
                placeholder: 'Ładowanie promptu systemowego...',
                emptyError: 'Prompt systemowy nie może być pusty!',
                saveSuccess: '✓ Prompt systemowy zapisany pomyślnie!',
                loadError: 'Błąd przy ładowaniu promptu systemowego',
                saveError: 'Błąd przy zapisywaniu'
            },
            llmProfiles: {
                addButton: '+ Dodaj Nowe Połączenie',
                newConnection: 'Nowe Połączenie',
                editConnection: 'Edytuj Połączenie',
                emptyState: 'Brak dostępnych połączeń LLM. Kliknij poniżej, aby dodać jedno.',
                loadingProfiles: 'Ładowanie profili...',
                nameLabel: 'Nazwa *',
                namePlaceholder: 'np. OpenAI GPT-4',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'Klucz API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, itp.',
                allFieldsRequired: 'Wszystkie pola muszą być wypełnione!',
                saveSuccess: '✓ Profil zapisany pomyślnie!',
                deleteConfirm: 'Czy na pewno chcesz usunąć "{name}"?',
                profileNotFound: 'Profil nie znaleziony!',
                loadError: 'Błąd przy ładowaniu profili',
                saveError: 'Błąd przy zapisywaniu',
                activateError: 'Błąd przy aktywowaniu',
                deleteError: 'Błąd przy usuwaniu',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Dodaj Nowy Głos',
                newVoice: 'Nowy Głos',
                editVoice: 'Edytuj Głos',
                emptyState: 'Brak dostępnych profili TTS. Kliknij poniżej, aby dodać jeden.',
                loadingProfiles: 'Ładowanie profili TTS...',
                nameLabel: 'Nazwa',
                namePlaceholder: 'np. Mój ElevenLabs Adam',
                providerLabel: 'Dostawca',
                providerPlaceholder: 'np. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Lokalny)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'Klucz API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Modelu *',
                modelIdPlaceholder: 'np. eleven_monolingual_v1',
                voiceIdLabel: 'ID Głosu',
                voiceIdPlaceholder: 'np. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Wszystkie pola muszą być wypełnione!',
                saveSuccess: '✓ Profil TTS zapisany pomyślnie!',
                deleteConfirm: 'Czy na pewno chcesz usunąć "{name}"?',
                loadError: 'Błąd przy ładowaniu profili TTS',
                saveError: 'Błąd przy zapisywaniu',
                activateError: 'Błąd przy aktywowaniu',
                deleteError: 'Błąd przy usuwaniu'
            },
            language: {
                title: 'Wybierz Język',
                description: 'Wybierz preferowany język interfejsu użytkownika'
            },
        },
        chat: {
            ready: 'Gotowy',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Kliknij START dla rozmowy w czasie rzeczywistym.',
            listening: 'Słucham...',
            speaking: 'Thorsten mówi...',
            userLabel: 'Ty',
            aiLabel: 'AI',
            modalTitle: 'Chat AI Thorsten',
            inputPlaceholder: 'Wpisz wiadomość...',
            send: 'Wyślij',
            loginRequired: 'Zaloguj się, aby korzystać z tej usługi.',
            loginButton: 'Zaloguj się Teraz',
            magicLinkRequired: 'Użyj magicznego linku, aby się zalogować.',
            creditLimitError: 'Twój przydział godzinowy został wyczerpany. Uaktualnij plan (Medium/Premium), aby kontynuować.',
            serviceDisabled: 'Usługa czatu jest obecnie niedostępna. Spróbuj ponownie później.'
        },
        notifications: {
            error: 'Błąd',
            success: 'Sukces',
            info: 'Informacja',
            unknownError: 'Wystąpił nieznany błąd'
        },
        cookie: {
            message: 'Ta strona internetowa używa cookies, aby zapewnić Ci jak najlepsze doświadczenie.',
            accept: 'Akceptuj'
        },
        curriculum: {
                buttonLabel: 'Program nauczania',
                buttonTitle: 'Pokaż treść programu nauczania',
                modalTitle: 'Program nauczania {app}',
                sections: {
                    topic: 'Temat programu nauczania',
                    explanation: 'Wyjaśnienie dla dzieci',
                    studentProfile: 'Profil ucznia'
                },
                topic: {
                    empty: 'Żaden temat programu nauczania nie jest powiązany z tą mikro-aplikacją w backendzie.',
                    missingDetail: 'Szczegółowe dane programu nauczania dla tej mikro-aplikacji nie są jeszcze dostępne w backendzie.',
                    learningGoals: 'Cele nauczania',
                    prerequisites: 'Wymagania wstępne',
                    unitLabel: 'Jednostka',
                    durationLabel: 'Czas trwania',
                    difficultyLabel: 'Poziom trudności',
                    hours: 'godz.',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Brak wyjaśnienia dla dzieci.',
                    loadingPrepare: 'AI przygotowuje wyjaśnienie',
                    loadingExplain: 'AI wyjaśnia temat językiem zrozumiałym dla dzieci',
                    requestFailed: 'Nie udało się wygenerować wyjaśnienia dla dzieci.'
                },
                studentProfile: {
                    country: 'Kraj',
                    region: 'Województwo / Region',
                    schoolType: 'Typ szkoły',
                    grade: 'Klasa',
                    noContext: 'Brak kontekstu ucznia.',
                    childProfileNotFound: 'Nie znaleziono profilu ucznia w backendzie dla bieżącego logowania.',
                    loginProfileIncomplete: 'Profil logowania nie zawiera jeszcze pełnego kontekstu ucznia.',
                    educationContextNotFound: 'Znaleziono profil ucznia, ale nie ustawiono przypisania programu nauczania.',
                    noToken: 'Nie znaleziono zalogowanego ucznia.'
                },
                errors: {
                    signInRequired: 'Zaloguj się, aby wyświetlić program nauczania.',
                    appIdMissing: 'Brak identyfikatora aplikacji.',
                    loadFailed: 'Nie można załadować danych programu nauczania.'
                }
            }
    };
